import { render, staticRenderFns } from "./product-certificate-select.vue?vue&type=template&id=bd1c733e&"
import script from "./product-certificate-select.vue?vue&type=script&lang=js&"
export * from "./product-certificate-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports